import { CircularFrame } from '@pinwheel/origami';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useOpts } from '../context';
import { BG_COLORS } from '../views/SearchLegacy/SearchResults';
import PlaidAccountCircleGeneric from '../assets/plaid-account-circle-generic.svg';
import { selectLinkApiResponse, selectLoadedPlatform, } from '../state/slices/slice-link-api';
import { getLinkApiTemplateType } from '../LinkApiRouter/utils/link-api-response';
var CompanyIcon = function (_a) {
    var result = _a.result, logoUrlOverride = _a.logoUrlOverride, _b = _a.loading, loading = _b === void 0 ? false : _b, backgroundColor = _a.backgroundColor, _c = _a.dataTestId, dataTestId = _c === void 0 ? 'logo' : _c, _d = _a.size, size = _d === void 0 ? 'sm' : _d;
    var id = result.id, _e = result.name, name = _e === void 0 ? '' : _e;
    var _f = useOpts(), topPlatformsImages = _f.topPlatformsImages, featureFlags = _f.featureFlags;
    var logoUrl = (id && topPlatformsImages && topPlatformsImages[id]) ||
        logoUrlOverride ||
        result.logoUrl;
    var generic = useMemo(function () {
        var _a;
        return (React.createElement("div", { "data-testid": "".concat(dataTestId, "-generic"), className: "searchResult-generic", style: { backgroundColor: backgroundColor || BG_COLORS[0] } }, (_a = name[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()));
    }, [backgroundColor, name, dataTestId]);
    var nongeneric = useMemo(function () { return React.createElement("img", { "data-testid": "".concat(dataTestId, "-img"), src: logoUrl, alt: "" }); }, [logoUrl, dataTestId]);
    var plaidCustomGenericLogo = useMemo(function () { return (React.createElement("img", { "data-testid": "".concat(dataTestId, "-img"), src: PlaidAccountCircleGeneric, alt: "" })); }, [dataTestId]);
    var loadedPlatform = useSelector(selectLoadedPlatform);
    var linkApiResponse = useSelector(selectLinkApiResponse);
    var el = useMemo(function () {
        // If enabled, replaces all platform/employer logos with a generic logo.
        // NOTE: the current generic logo being used is a custom logo directly from
        // Plaid. If we ever want to extend this functionality to other clients in
        // the future, we will likely need to find/create another logo.
        if (featureFlags.useGenericProviderLogos) {
            // Plaid wants generic logos shown everywhere *except* the search/mappings
            // views before the login credentials steps, in which the actual company
            // logos are shown: https://pinwheel.atlassian.net/browse/CON-533
            var templateType = getLinkApiTemplateType(linkApiResponse);
            // NOTE: this must be updated to include additional templates from the
            // provider confirmation flow:
            // https://www.notion.so/pinwheelapi/Provider-Confirmation-Flow-f7e281ce5d9143f1ae2e3b50b4ed4559
            if (loadedPlatform &&
                !['provider_selection', 'search'].includes(templateType)) {
                return plaidCustomGenericLogo;
            }
        }
        return loading || logoUrl ? nongeneric : generic;
    }, [
        loading,
        logoUrl,
        generic,
        nongeneric,
        featureFlags.useGenericProviderLogos,
        plaidCustomGenericLogo,
        loadedPlatform,
        linkApiResponse,
    ]);
    return (React.createElement(CircularFrame, { loading: loading, size: size }, el));
};
export default CompanyIcon;
